/* eslint-disable vue/max-len */

import {RouteConfig} from 'vue-router/types/router';
import routeConfigTablet from '@csp-app/app/routes/tablet';
import routeConfigRecordCreationByCustomer from '@csp-app/app/routes/recordCreationByCustomer';
import routeConfigExternalServiceDocumentation from '@csp-app/app/routes/externalServiceDocumentation';

export default class ModeSwitcher {
  public getMode(): string {
    const mode = '' + (new URLSearchParams(window.location.search)).get('mode');
    const routes = this.getRoutesByMode();
    if (mode in routes) {
      // only use mode from get param, if mode is present in our routes config = validation
      return mode;
    }
    return 'tablet';
  }

  public getModeComponent(): string {
    const componentSuffixMapping: { [key: string]: string } = {
      signDocuments: 'sign-documents',
      recordCreationByCustomer: 'record-creation-by-customer',
      externalServiceDocumentation: 'external-service-documentation',
      passwordReset: 'password-reset',
      loginSecondFactor: 'login-second-factor',
    };
    const mode = this.getMode();
    let componentSuffix = mode;
    if (mode in componentSuffixMapping) {
      componentSuffix = componentSuffixMapping[mode];
    }
    return 'csp-mode-' + componentSuffix;
  }

  public getRoutes(): RouteConfig[] {
    const mode = this.getMode();
    return this.getRoutesByMode()[mode];
  }

  private getRoutesByMode(): { [key: string]: RouteConfig[] } {
    return {
      signDocuments: [],
      recordCreationByCustomer: routeConfigRecordCreationByCustomer,
      tablet: routeConfigTablet,
      externalServiceDocumentation: routeConfigExternalServiceDocumentation,
      passwordReset: [],
      loginSecondFactor: [],
    }
  }
}
